import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { apiGet } from "@/lib/apiAdmin";
import { JarvisOrb } from "./JarvisOrb";
import { JarvisChat } from "./JarvisChat";

export const JarvisDock = () => {
  const [open, setOpen] = useState(false);
  const [st, setSt] = useState(null);
  useEffect(() => {
    if (open && !st) apiGet("/admin/jarvis/status").then(setSt).catch(() => {});
  }, [open, st]);

  return (
    <>
      <motion.button
        onClick={() => setOpen(true)}
        data-testid="jarvis-dock-open"
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        whileHover={{ scale: 1.08 }}
        className="fixed bottom-5 right-5 z-[150] w-16 h-16 rounded-full bg-[#05080C] border border-cyan-400/30 flex items-center justify-center shadow-[0_0_40px_rgba(34,229,255,0.35)]"
        title="Talk to JARVIS"
      >
        <JarvisOrb size={44} />
      </motion.button>
      <AnimatePresence>
        {open && (
          <motion.div className="fixed inset-0 z-[210] flex justify-end" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
            <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={() => setOpen(false)} />
            <motion.div
              initial={{ x: 480 }}
              animate={{ x: 0 }}
              exit={{ x: 480 }}
              transition={{ type: "spring", damping: 28, stiffness: 260 }}
              className="relative w-full max-w-[440px] h-full p-2 sm:p-3"
              data-testid="jarvis-dock-panel"
            >
              <JarvisChat onClose={() => setOpen(false)} name={st?.assistant_name} title={st?.owner_title} speakDefault={st?.speak_replies ?? true} className="h-full bg-[#070B10]" />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default JarvisDock;
